import React from 'react';
import { Trans } from '@lingui/react/macro';
import theme from './BuyerChangeRequestParticipantOfferLines.module.scss';
import { BuyerOfferLine } from '@/types';
import { sumBy } from 'lodash-es';
import { BuyerCurrencyDisplay } from '../BuyerCurrencyDisplay';
import ItemCategoryDisplay from '@/components/item-categories/ItemCategoryDisplay';
import ReadyToggleCard from '@/components/ReadyToggleCard';

interface BuyerChangeRequestParticipantOfferLinesProps {
    offerLines: BuyerOfferLine[] | null;
    isReadyToSend?: boolean;
    onReadyStateChange?: (checked: boolean) => void;
    canChangeOffer?: boolean;
}

const BuyerChangeRequestParticipantOfferLines: React.FC<BuyerChangeRequestParticipantOfferLinesProps> = ({
    offerLines,
    isReadyToSend = false,
    onReadyStateChange,
    canChangeOffer = false,
}) => {
    if (!offerLines || offerLines.length === 0) {
        return null;
    }

    const renderTotalPrice = () => {
        return <BuyerCurrencyDisplay value={sumBy(offerLines, (x) => x.finalPrice!)} />;
    };

    return (
        <div className={theme.priceBreakdown}>
            <h6>
                <Trans>Price breakdown</Trans>
            </h6>
            <table className="table style-3">
                <thead>
                    <tr>
                        <th>
                            <Trans>Description</Trans>
                        </th>
                        <th>
                            <Trans>Category</Trans>
                        </th>
                        <th className="nowrap text-right">
                            <Trans>Amount</Trans>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {offerLines.map((line) => (
                        <tr key={line.id}>
                            <td>{line.description}</td>

                            <td>
                                <ItemCategoryDisplay value={line.itemCategoryId} type="root" />
                            </td>
                            <td className="nowrap text-right">
                                <BuyerCurrencyDisplay value={line.finalPrice || 0} />
                            </td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                        <th colSpan={2}>
                            <Trans>Subtotal</Trans>
                        </th>
                        <th className="text-right">{renderTotalPrice()}</th>
                    </tr>
                </tfoot>
            </table>

            {canChangeOffer && onReadyStateChange && (
                <ReadyToggleCard checked={isReadyToSend} onChange={onReadyStateChange} />
            )}
        </div>
    );
};

export default BuyerChangeRequestParticipantOfferLines;
